/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Section from 'components/section';
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Navigation from 'modules/me/navigation';
import UploadForm from './upload-form';
import { requestInProgressOperation } from 'state/import-operation/actions';
import OperationProgress from './operation-progress';
import { getInProgressOperation } from 'state/import-operation/selectors';
import Placeholder from './placeholder';
import TrashData from './trash-data';
import LastImported from './last-imported';
import PageHeader from 'layout/page-header';

/**
 * Style dependencies
 */
import './styles.scss';

const Data = (props) => {
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		checkOperation();
	}, []);

	const checkOperation = async () => {
		try {
			await props.requestInProgressOperation();
		} catch (error) {}
		setLoaded(true);
	};

	return (
		<>
			<PageHeader title='Settings' />
			<Main>
				<DocumentHead title='Data' />
				<Navigation section='data' />
				<Section label='Import Data'>
					<OperationProgress />
					{!props.operation && !loaded && <Placeholder />}
					{loaded && !props.operation && <UploadForm />}
				</Section>
				<LastImported />
				<TrashData />
			</Main>
		</>
	);
};

export default connect((state) => ({ operation: getInProgressOperation(state) }), {
	requestInProgressOperation,
})(Data);
